import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWelcomeSimulate = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#F8FAFB",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		transform: "translate(2 2)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 1.5
		}), /* @__PURE__ */ _jsx("path", { d: "M5 4.574c0-.53.36-.728.803-.445l8.365 5.356c.443.284.442.746 0 1.03L5.803 15.87c-.443.284-.803.086-.803-.445z" })]
	})
});
export default SvgWelcomeSimulate;
